import ReactApexChart from 'react-apexcharts'
import { Box, Typography, Stack, Card } from '@pankod/refine-mui'

import { PieChartProps } from 'interfaces/home'
const PieChart = ({ title, value, series, colors }: PieChartProps) => {
  //  <Card
  //       id="chart"
  //       sx={{
  //         flex: 1,
  //         display: 'flex',
  //         flexDirection: 'row',
  //         justifyContent: 'space-between',
  //         alignItems: 'center',
  //         pl: '3.5',
  //         py: '2',
  //         gap: '2',
  //         borderRadius: '15px',
  //         minHeight: '110px',
  //         width: 'fit-content',
  //         // width: '100%',
  //       }}
  //     >
  return (
    <Box
      id="chart"
      flex={1}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box
        flex={1}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        pl={3.5}
        py={2}
        gap={2}
        borderRadius="15px"
        minHeight="110px"
        // width="fit-content"
        width="100%"
        // background-color: #242424;
        component={Card}
        // bgcolor="#fcfcfc"
        // bgcolor="#242424"

        sx={{
          // maxWidth: '330px',
          // padding: '10px',
          backgroundImage:
            'linear-gradient(rgba(255, 255, 255, 0.025), rgba(255, 255, 255, 0.025))',
          '&:hover': {
            // boxShadow: '0 22px 45px 2px rgba(176, 176, 176, 0.1)',

            backgroundImage:
              // 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
              'linear-gradient(rgba(255, 255, 255, 0.05), rgba(176, 176, 176, 0.1))',
            boxShadow:
              '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
            webkitTransition:
              'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          },
          // cursor: 'pointer',
        }}
      >
        <Stack direction="column">
          <Typography fontSize={14} color="#808191">
            {title}
          </Typography>
          <Typography
            fontSize={24}
            // color="#11142d"
            fontWeight={700}
            mt={1}
          >
            {value}
          </Typography>
        </Stack>

        <ReactApexChart
          options={{
            chart: { type: 'donut' },
            colors,
            legend: { show: false },
            dataLabels: { enabled: false },
          }}
          series={series}
          type="donut"
          width="120px"
        />
      </Box>
    </Box>
  )
}

export default PieChart
